import React, { useEffect, useState, useRef } from 'react';
import UseToast from '../UseToast';
import { UseTranslationData, getRandomMessage } from '../UseTranslationData';


const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
recognition.continuous = false; // Change to false for single recognition session
recognition.interimResults = true;

const AudioToTextJavaScript = ({
  siteBrandColor,
  onstartConverting,
  onstopRecording,
  translationData,
  aiFormData,
  onplayPromoMessage,
  onsessionInfo,
  // onSpeechRecognitionEnd,
  onstartspeech,
  rizwanScriptStep,
  setonstartspeech,
  rizwanScriptStepEnglishRef,
  rizwanButtonFun,
  onfaceDetectionStartSpeech,
  setfaceDetectionStartSpeech,
  isInRangeRefFun,
  onplayUserSilenceMsg,
  playRandomSpeech,
  idealMode,
  resetLoopVideoBtnCase,
  waitingTime,
  disableSpeechButton,
  startAutoButtonSpeech,
  setStartAutoButtonSpeech
}) => {
  const [currentRecognition, setCurrentRecognition] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const silenceTimer = useRef(null);
  const inactivityTimer = useRef(null);
  const recognitionTimer = useRef(null); // Timer to stop recognition after 10 seconds
  const currentRecognitionRef = useRef('');
  const [disabledState, setDisabledState] = useState(disableSpeechButton);
  const onsessionInfoRef = useRef(onsessionInfo);
  const rizwanScriptStepRef = useRef(rizwanScriptStep);

  const { showSuccessToast, dismissToast, showWarningToast } = UseToast();
  const [currentRecognitionLang, setCurrentRecognitionLang] = useState('');
  const currentRecognitionLangListenRef = useRef('');
  const currentRecognitionLangRef = useRef('');
  const [currentText, setCurrentText] = useState('');
  const [autoStart, setAutoStart] = useState(false);
  const [showStartButton, setShowStartButton] = useState(true);


  const [hasSessionStarted, setHasSessionStarted] = useState(false);



  const words =
    "Welcome! I've let Amy know you are here. Is there anything else I can help you with?".split(
      ' '
    );


  // keep a local state in sync with the parent prop so renders update reliably
  useEffect(() => {
    setDisabledState(disableSpeechButton);
  }, [disableSpeechButton]);

  useEffect(() => {
    setAutoStart(startAutoButtonSpeech);
  }, [startAutoButtonSpeech]);

  // Handle microphone input setup
  useEffect(() => {
    if (window.location.protocol === 'http:' && !window.location.hostname.includes('localhost')) {
      showWarningToast('Microphone access blocked: Use HTTPS domain');
      return;
    }
    if (!navigator.mediaDevices) {
      showWarningToast('MediaDevices API not supported in this browser');
      return;
    }
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(stream => {
        // Code to start recognition if microphone is available
        recognition.lang = 'en-US';
        recognition.onresult = handleSpeechRecognition;
        recognition.onend = () => {
          console.log('Recognition ended.');
          if (isRecording) recognition.start();
        };

        recognition.onerror = function (event) {
          console.log('microphone error', event.error);
        };
      })
      .catch(error => {
        console.error('Microphone access denied', error);
      });
  }, [isRecording]);




  useEffect(() => {
    let timeoutId;

    if (aiFormData.enable_face_detection === 'yes' && !isInRangeRefFun) {
      // Set a timeout to wait for 2 seconds
      timeoutId = setTimeout(() => {
        // Re-check the condition to ensure user is still out of range
        if (!isInRangeRefFun) {
          const stopRecording = document.getElementById('stoprecording');

          console.log('click');
          // if (stopRecording) {
          //   stopRecording.click(); // Trigger the stop recording action
          // }
        }
      }, 2000); // Wait for 2 seconds
    }

    // Cleanup function to clear timeout if isInRangeRefFun changes back to true
    return () => clearTimeout(timeoutId);
  }, [isInRangeRefFun]);

  useEffect(() => {
    // console.log("isInRangeRefFun",isInRangeRefFun)

    if (onfaceDetectionStartSpeech && isInRangeRefFun) {
      recognition.stop();

      const ai_starttalk = document.getElementById('ai_starttalk');
      if (ai_starttalk) {
        ai_starttalk.click();
      }
    }
  }, [onfaceDetectionStartSpeech]);

  useEffect(() => {

    if (autoStart && !idealMode && aiFormData?.enable_face_detection !== 'yes') {
      const ai_starttalk = document.getElementById('ai_starttalk');
      if (ai_starttalk) {
        ai_starttalk.click();
      }

      if (aiFormData?.enable_auto_speech_response && showStartButton && !idealMode) {
        // Hide start button after first click
        setShowStartButton(false);
      }
    }
  }, [autoStart]);

  useEffect(() => {
    currentRecognitionRef.current = currentRecognition;
  }, [currentRecognition]);

  useEffect(() => {
    currentRecognitionLangRef.current = currentRecognitionLang;
    let listenWord;
    listenWord = UseTranslationData(aiFormData, currentRecognitionLang.split('-')[0]);
    currentRecognitionLangListenRef.current = listenWord?.listening_text;

  }, [currentRecognitionLang, disabledState]);

  const buttonTextMessage = () => {
    let listenWord;
    listenWord = UseTranslationData(aiFormData, currentRecognitionLang.split('-')[0]);
    if (aiFormData?.isButtonSelectMsgOn && listenWord?.button_select_message) {

      currentRecognitionLangListenRef.current = getRandomMessage(listenWord?.button_select_message || 'Listening...');
    } else {
      currentRecognitionLangListenRef.current = listenWord?.listening_text;
    }
  }

  useEffect(() => {
    if (onsessionInfo) {
      setHasSessionStarted(true);
    }

    onsessionInfoRef.current = onsessionInfo;
  }, [onsessionInfo]);


  const startRecording = () => {
    playSound();
    if (aiFormData?.enable_face_detection !== 'yes' && idealMode) {
      resetLoopVideoBtnCase();
      return;
    }

    // Prevent double start
    if (isRecording) {
      // Already recording, do not start again
      return;
    }

    setIsRecording(true);

    try {
      recognition.start();
    } catch (err) {
      console.warn('SpeechRecognition already started:', err);
    }
    //startSilenceTimer();
    startRecognitionTimer(); // Start 10-second timer

    if (aiFormData.enable_rizwan_event !== 'yes' && aiFormData.enable_face_detection !== 'yes') {
      document.getElementById('ai_starttalk').style.display = 'none'
      document.getElementById('stoprecording').style.display = 'block';
    }
    currentRecognitionRef.current = null;
  };



  const stopRecording = () => {
    setIsRecording(false);
    recognition.stop();
    clearSilenceTimer();
    clearRecognitionTimer(); // Clear the recognition timer

    dismissToast();

    //showWarningToast("Recording stopped.");
    const finalRecognition = currentRecognitionRef.current;
    const finalRecognitionLang = currentRecognitionLangRef.current;



    if (aiFormData.enable_face_detection === 'yes' && !isInRangeRefFun) {
      currentRecognitionRef.current = null;
      setfaceDetectionStartSpeech();
      setDisabledState(disableSpeechButton);
      return;
    }

    if (finalRecognition) {
      onstopRecording(finalRecognition, finalRecognitionLang.split('-')[0]);

      if (aiFormData.enable_face_detection === 'yes' && aiFormData.enable_rizwan_event !== 'yes') {
        setfaceDetectionStartSpeech();
      }

      if (aiFormData?.enable_auto_speech_response) {
        setStartAutoButtonSpeech();
      }


    } else {
      playUserSilenceMessage();
    }

    if (aiFormData.enable_rizwan_event !== 'yes' && aiFormData.enable_face_detection !== 'yes') {
      document.getElementById('ai_starttalk').style.display = 
      aiFormData?.enable_auto_speech_response && !showStartButton ? 'none':'flex';
      document.getElementById('stoprecording').style.display = 'none';
    }

    // restore disabled state based on parent prop after stopping
    setDisabledState(disableSpeechButton);
  };

  const handleSpeechRecognition = event => {
    clearSilenceTimer(); // Reset silence timer upon hearing speech
    let finalTranscript = '';

    console.log('event', event);

    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        finalTranscript += stringConversion(event.results[i][0].transcript);
        setCurrentRecognitionLang(event.target.lang);
        currentRecognitionLangRef.current = event.target.lang;
      }
    }

    if (finalTranscript) {
      setCurrentRecognition(finalTranscript);
      currentRecognitionRef.current = finalTranscript; // Update ref here for latest value
      resetInactivityTimer();

      const totalTextWordCount = finalTranscript.split(/\s+/).length;

      console.log('aiFormData', aiFormData);

      if (totalTextWordCount <= 2 && aiFormData?.isTwoWordsEnabled) {
        playRandomSpeech(onsessionInfoRef.current);

        setIsRecording(false);
        recognition.stop();
        clearSilenceTimer();
        clearRecognitionTimer(); // Clear the recognition timer
        dismissToast();

        if (
          aiFormData.enable_rizwan_event !== 'yes' &&
          aiFormData.enable_face_detection !== 'yes'
        ) {
          document.getElementById('ai_starttalk').style.display = 
          aiFormData?.enable_auto_speech_response && !showStartButton ? 'none':'flex';
          document.getElementById('stoprecording').style.display = 'none';
        }

        if (aiFormData.enable_face_detection === 'yes') {
          setfaceDetectionStartSpeech();
        }
        if (aiFormData?.enable_auto_speech_response) {
          setStartAutoButtonSpeech();
        }
      } else {
        stopRecording(); // Stop recording after final speech is captured
      }
    }
  };

  const stringConversion = searchText => {
    // Get individual replacements from translationData
    const textArray = translationData?.text_replace.split('\n').filter(item => item.trim() !== '');

    // Split the search text into words, using regular expressions to account for line breaks or special characters
    const wordsToSearch = searchText.split(/\s+/);

    console.log('Original wordsToSearch', wordsToSearch);

    // Function to normalize words by removing special characters and converting to lowercase
    const normalizeWord = word => word.replace(/[^\w\s]/gi, '').toLowerCase();

    // Update each word in the search text if it matches any translationData replacements
    const updatedText = wordsToSearch
      .map(word => {
        const normalizedWord = normalizeWord(word);

        // Iterate through textArray to find matching replacements
        for (let item of textArray) {
          const [lhs, rhs] = item.split('|').map(part => part.trim());
          const normalizedLHS = normalizeWord(lhs);

          // If a normalized word matches normalized LHS, replace it with RHS
          if (normalizedLHS === normalizedWord) {
            return rhs; // Replace matched word
          }
        }
        return word; // Return unchanged word if no match found
      })
      .join(' ');

    console.log('Updated Text', updatedText);
    return updatedText;
  };

  // const startSilenceTimer = () => {
  //   if (silenceTimer.current) clearTimeout(silenceTimer.current);
  //   silenceTimer.current = setTimeout(() => {
  //     playUserSilenceMessage();
  //   }, 10000); // 10 seconds silence timeout
  // };

  const clearSilenceTimer = () => {
    if (silenceTimer.current) clearTimeout(silenceTimer.current);
  };

  const startRecognitionTimer = () => {
    //showSuccessToast('Speak Now...');

    if (recognitionTimer.current) clearTimeout(recognitionTimer.current);
    recognitionTimer.current = setTimeout(() => {
      stopRecording(); // Stop recording after 10 seconds
    }, 12000); // 10 seconds
  };

  const clearRecognitionTimer = () => {
    if (recognitionTimer.current) clearTimeout(recognitionTimer.current);
  };

  const resetInactivityTimer = () => {
    if (inactivityTimer.current) clearTimeout(inactivityTimer.current);

    // Check if promo_time_limit exists and is not 0
    if (aiFormData?.promo_time_limit && aiFormData?.promo_time_limit > 0) {
      inactivityTimer.current = setTimeout(
        () => {
          playPromoMessage();
        },
        aiFormData?.promo_time_limit * 60 * 1000
      ); // Promo timeout based on aiFormData
    }
  };
  const playPromoMessage = () => {
    onplayPromoMessage(onsessionInfoRef.current);
    resetInactivityTimer();
  };

  const playUserSilenceMessage = () => {
    if (aiFormData.enable_rizwan_event !== 'yes') {
      onplayUserSilenceMsg(onsessionInfoRef.current);
      // disableSpeechButtonRef.current = false;

      if (aiFormData?.enable_auto_speech_response) {
        setStartAutoButtonSpeech();
        setShowStartButton(true);
      }

      if (aiFormData.enable_face_detection === 'yes') {
        setfaceDetectionStartSpeech();
      }
    }
  };



    const playSound = () => {
    const audioUrl = aiFormData?.click_sound_audio;
    const volume = aiFormData?.click_sound_volume || 1;
    if (audioUrl && showStartButton && aiFormData?.enable_face_detection !== 'yes') {
      const audio = new Audio(audioUrl);
      audio.volume = volume || 1;

      audio.play().catch(error => {
        console.error('Audio playback failed:', error);

      });
    }
  };
  
    useEffect(() => {
      if (idealMode) {
        setShowStartButton(true);
      }
    }, [idealMode]);


  return (
    <div>
      {aiFormData?.enable_speech_btn === 'yes' && (
        <>
          <button
            type="button"
            className="ai_starttalk"
            id="ai_starttalk"
            style={{
              backgroundColor: disabledState ? 'gray' : siteBrandColor,
              display:
                (aiFormData.enable_face_detection === 'yes' || !showStartButton)
                  ? 'none'
                  : 'flex',
              opacity: disabledState ? 0.7 : 1,
              alignItems: 'center',
              justifyContent: 'center',
              gap: '1vw',
            }}
            //onClick={startRecording}
            onClick={(e) => {         
            
              if (disabledState && e?.isTrusted) return;
              startRecording();
            }}

            // disabled={disabledState}
          >
            {/* {waitingTime ? 'Please Wait...' : translationData?.ask_your_question} 
            // <span>{waitingTime || !onsessionInfoRef.current
            //   ? translationData?.avatar_before_loading_text || 'Please Wait...'
            //   : translationData?.ask_your_question}
            // </span>

            //  {!waitingTime && onsessionInfoRef.current &&
            //   <div><img src="/vendors/images/microphone-V2.png" alt="" style={{ width: "2.5vw" }} /></div>
            // } 
            */}

            <span>{(waitingTime || (!onsessionInfoRef.current && !hasSessionStarted)) && !idealMode
                ? translationData?.avatar_before_loading_text || 'Please Wait...'
              : translationData?.ask_your_question}
            </span>


            

             {!((waitingTime || (!onsessionInfoRef.current && !hasSessionStarted)) && !idealMode) ?
              <div><img src="/vendors/images/microphone-V2.png" alt="" style={{ width: "2.5vw" }} /></div>
              : null
            } 
          </button>


          <button
            type="button"
            className="ai_starttalk"
            id="stoprecording"
            style={{
              backgroundColor: disabledState ? 'gray' : siteBrandColor,
              display: aiFormData.enable_rizwan_event === 'yes' ? 'none' : '',
              opacity: disabledState ? 0.7 : 1,
            }}
            //onClick={stopRecording}
            onClick={(e) => {
              // Same guard for stop button: block user clicks when disabled, allow programmatic clicks.
              if (disabledState && e?.isTrusted) return;
              stopRecording();
            }}
            // disabled={disabledState}
          >
            {currentRecognitionLangListenRef.current
              ? currentRecognitionLangListenRef.current
              : 'Listening...'}
          </button>
          {/* 
          {(rizwanScriptStepRef.current === 1 || rizwanScriptStepRef.current === 2) &&
            aiFormData.enable_rizwan_event === 'yes' &&
            aiFormData?.enable_rizwan_btn === 'yes' && (
              <button
                type="button"
                className="ai_starttalk"
                style={{
                  backgroundColor: siteBrandColor,
                }}
                onClick={() => rizwanButtonFunRun()}
              >
                {rizwanScriptStep === 1
                  ? aiFormData?.enable_rizwan_btn_text_1
                  : aiFormData?.enable_rizwan_btn_text}
              </button>
            )} */}

          <div
            id="textresponse"
            style={{ fontSize: aiFormData.enable_rizwan_event === 'yes' ? '42px' : '20px' }}
          >
            {aiFormData.speech_text_response === 'yes' &&
              (aiFormData.enable_rizwan_event === 'yes' && rizwanScriptStepEnglishRef
                ? currentText
                : aiFormData.enable_rizwan_event === 'yes' && !rizwanScriptStepEnglishRef
                  ? ''
                  : currentRecognitionRef.current)}
          </div>
        </>
      )}
    </div>
  );
};

export default AudioToTextJavaScript;
